export default "__VITE_ASSET__VUl3Dvjp__"